import { UntypedFormGroup, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { DateTime as LuxonDateTime } from 'luxon';

class ValidationUtils {
  validateEqual(field, confirmField) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const password = group.controls[field];
      const confirmPassword = group.controls[confirmField];

      if (password.value !== confirmPassword.value) {
        return {
          mismatchedPasswords: true
        };
      }
    };
  }

  validateEmail(c: UntypedFormControl) {
    // Allow empty values (use Validators.required separately if needed)
    if (!c.value || c.value === '') {
      return null;
    }

    const EMAIL_REGEXP = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

    return EMAIL_REGEXP.test(c.value) ? null : {
      validateEmail: {
        valid: false
      }
    };
  }

  buildZipcodeValidation() {
    return Validators.compose([
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(5),
      Validators.pattern('[0-9]*')
    ]);
  }

  validateUrl(c: UntypedFormControl): ValidationErrors {
    // Allow empty values (use Validators.required separately if needed)
    if (!c.value || c.value === '') {
      return null;
    }

    try {
      const url = new URL(c.value);
      // Ensure it has a valid protocol (http, https, ftp)
      if (!['http:', 'https:', 'ftp:'].includes(url.protocol)) {
        return {valid: false};
      }
      return null;
    } catch {
      return {valid: false};
    }
  }

  timeRangesValidation(formsArray: Array<UntypedFormGroup>, intervalValidation = 30) {
    return (formGroup: UntypedFormGroup) => {
      const startControl = formGroup.controls.start_time;
      const endControl = formGroup.controls.end_time;

      const indexOfFormGp = formsArray.indexOf(formGroup);
      let startErrors = null;
      let endErrors = null;
      if (indexOfFormGp > 0) {
        const valid = startControl.value > formsArray[indexOfFormGp - 1].controls.end_time.value;
        startErrors = valid ? null : {invalidStartTime: true};
      }

      if (indexOfFormGp < formsArray.length - 1 && indexOfFormGp !== -1) {
        const valid = endControl.value < formsArray[indexOfFormGp + 1].controls.start_time.value;
        endErrors = valid ? null : {invalidEndTime: true};
      }

      // Check if start time is after or equal to end time (invalid range)
      if (startControl.value >= endControl.value) {
        const error = {invalidTimeRange: true};
        startErrors = {...startErrors, ...error};
        endErrors = {...endErrors, ...error};
      } else if (startControl.value && endControl.value) {
        // Only check interval if the time range is valid (start < end)
        const endTime = LuxonDateTime.fromFormat(endControl.value, 'HH:mm');
        const startTime = LuxonDateTime.fromFormat(startControl.value, 'HH:mm');
        const intervalDiff = endTime.diff(startTime, 'minutes').minutes;

        if (intervalDiff < intervalValidation) {
          const error = {intervalError: true};
          endErrors = {...endErrors, ...error};
        }
      }

      startControl.setErrors(startErrors);
      endControl.setErrors(endErrors);
    };
  }
}

export default new ValidationUtils();
